import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { BankInterfaceMonitoringMaintenanceProvider } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import BankInterfaceMonitoringMaintenance from "presentation/view/section/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const BankInterfaceMonitoringMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.BANK_INTERFACE_MONITORING_MAINTENANCE}>
        <MessageBarWrapper>
            <BankInterfaceMonitoringMaintenanceProvider>
                <GridStyles/>
                <BankInterfaceMonitoringMaintenance/>
            </BankInterfaceMonitoringMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default BankInterfaceMonitoringMaintenanceCont;